import React, { memo } from 'react';
import { Icon as IconHoi } from '@Sage/hoi-poi-ui';

import { default as Accounts } from './AccountsIcon';
import { default as Activities } from './ActivitiesIcon';
import { default as Analytics } from './AnalyticsIcon';
import { default as AnalyticsPro } from './AnalyticsProIcon';
import { default as AvoidDuplicates } from './AvoidDuplicatesIcon';
import { default as Calendar } from './CalendarIcon';
import { default as Campaigns } from './CampaignsIcon';
import { default as Contacts } from './ContactsIcon';
import { default as Credentials } from './CredentialsIcon';
import { default as Dashboard } from './DashboardIcon';
import { default as Documents } from './DocumentsIcon';
import { default as Download } from './DownloadIcon';
import { default as Excel } from './ExcelIcon';
import { default as Fields } from './FieldsIcon';
import { default as FieldsValidationsIcon } from './FieldsValidationsIcon';
import { default as Force } from './ForceIcon';
import { default as Forms } from './FormsIcon';
import { default as Functions } from './FunctionsIcon';
import { default as Goals } from './GoalsIcon';
import { default as ImportsAlt } from './ImportsAltIcon';
import { default as Imports } from './ImportsIcon';
import { default as List } from './ListIcon';
import { default as Literals } from './LiteralsIcon';
import { default as News } from './NewsIcon';
import { default as Opportunities } from './OpportunitiesIcon';
import { default as Parameters } from './ParametersIcon';
import { default as Products } from './ProductsIcon';
import { default as Quotes } from './QuotesIcon';
import { default as Reports } from './ReportsIcon';
import { default as Roles } from './RolesIcon';
import { default as SalesOrders } from './SalesOrdersIcon';
import { default as Sandbox } from './SandboxIcon';
import { default as Upload } from './UploadIcon';
import { default as Users } from './UsersIcon';
import { default as Widgets } from './WidgetsIcon';
import { default as Crons } from './CronsIcon';
import { default as WorkSpace } from './WorkSpaceIcon';
import { default as TrialIcon } from './TrialIcon';
const Icon = ({ name, ...props }) =>
    ({
        accounts: <Accounts {...props} />,
        activities: <Activities {...props} />,
        analytics: <Analytics {...props} />,
        analyticsPro: <AnalyticsPro {...props} />,
        avoidDuplicates: <AvoidDuplicates {...props} />,
        calendar: <Calendar {...props} />,
        campaigns: <Campaigns {...props} />,
        contacts: <Contacts {...props} />,
        credentials: <Credentials {...props} />,
        dashboard: <Dashboard {...props} />,
        documents: <Documents {...props} />,
        download: <Download {...props} />,
        excel: <Excel {...props} />,
        fields: <Fields {...props} />,
        fieldsValidations: <FieldsValidationsIcon {...props} />,
        force: <Force {...props} />,
        forms: <Forms {...props} />,
        functions: <Functions {...props} />,
        goals: <Goals {...props} />,
        importsAlt: <ImportsAlt {...props} />,
        imports: <Imports {...props} />,
        list: <List {...props} />,
        literals: <Literals {...props} />,
        news: <News {...props} />,
        opportunities: <Opportunities {...props} />,
        parameters: <Parameters {...props} />,
        products: <Products {...props} />,
        quotes: <Quotes {...props} />,
        reports: <Reports {...props} />,
        roles: <Roles {...props} />,
        salesOrders: <SalesOrders {...props} />,
        sandbox: <Sandbox {...props} />,
        upload: <Upload {...props} />,
        users: <Users {...props} />,
        widgets: <Widgets {...props} />,
        crons: <Crons {...props} />,
        workspace: <WorkSpace {...props} />,
        trialIcon: <TrialIcon {...props} />,
        dashboardWeb: <IconHoi name="dashboard" {...props} />,
        integrations: <IconHoi name="integrations" {...props} />,
    })[name] || `Missing icon ${name}`;

export default memo(Icon);
